import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'buildings',
    component: Children,

    children: [
      {
        path: '',
        name: 'buildings',
        component: () => import('../pages/BuildingsPage.vue')
      }
    ]
  }
];

export default routes;
